import { http } from '../utils/axios';
import { TNoteCreateAction } from '../types';
import { INote } from '../interfaces/note.interface';

class NoteService {
  private static instance: NoteService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): NoteService {
    if (!NoteService.instance) {
      NoteService.instance = new NoteService();
    }

    return NoteService.instance;
  }

  public createNote = async (payload: TNoteCreateAction) => {
    const { data } = await http<INote>({
      url: '/notes',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public getVisitNotes = async (visitId: string) => {
    const { data } = await http<INote[]>({
      url: `/notes/visits/${visitId}`,
      method: 'GET'
    });

    return data;
  };

  public getOrderNotes = async (orderId: string) => {
    const { data } = await http<INote[]>({
      url: `/notes/orders/${orderId}`,
      method: 'GET'
    });

    return data;
  };

  public getPatientNotes = async (patientId: string) => {
    const { data } = await http<INote[]>({
      url: `/notes/patient/${patientId}`,
      method: 'GET'
    });

    return data;
  };

  public deleteNote = async (noteId: string) => {
    const { data } = await http<INote[]>({
      url: `/notes/${noteId}`,
      method: 'DELETE'
    });

    return data;
  };
}

const instance = NoteService.getInstance();

export default instance;
